var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopPopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 110,
    viewBox: "0 0 104 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.348 75.7885V75.6353H92.8295V21.8727C92.8295 18.4787 90.0836 15.7328 86.6895 15.7328H23.7583V9.68717H17.8777V0H7.76623V10.1114H17.642V15.8035H23.7112V28.6844H10.1821V23.0159H4.054V29.144H9.8168V75.7885C4.32505 76.2953 0 80.9385 0 86.5599V104.815C0 107.678 2.32162 110 5.18534 110H97.9677C100.831 110 103.153 107.678 103.153 104.815V86.5599C103.153 80.9385 98.8397 76.2953 93.3362 75.7885H93.348ZM23.9586 28.6844H78.9351V75.7414H23.9586V28.6844ZM89.0229 95.8582H14.1418V89.8714H89.0229V95.8582Z",
    fill: "url(#paint0_radial_2570_246)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2570_246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.25091 109.623) scale(139.851 139.851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EF39C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0EED9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#10DCA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#14C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#189AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1E68D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#262EED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPopupIcon);
export default __webpack_public_path__ + "static/media/desktopPopupIcon.4224cade1b1bda5c5c59c17280ffc961.svg";
export { ForwardRef as ReactComponent };